// tslint:disable-next-line:no-submodule-imports
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { catchError } from "rxjs/operators";
import { HttpUtilsService, QueryParamsModel, QueryResultsModel } from "../../_base/crud";
import { environment } from "../../../../environments/environment";

const API_INVOICING_DETAIL_URL = environment.API_URL + "api/invoicing/details";

@Injectable({
  providedIn: "root"
})
export class InvoicingJobDetailService {
  // TODO: NGRX error handling

  constructor(private http: HttpClient, private httpUtils: HttpUtilsService) {}

  findInvoicingDetails(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = API_INVOICING_DETAIL_URL + "/find";
    return this.http
      .post<QueryResultsModel>(url, queryParams, { headers: httpHeaders })
      .pipe(catchError((err) => of(null)));
  }
}
